import gql from "graphql-tag";
import { PageFragment } from "../fragments/page.fragment";
import { RebateFragment } from "../fragments/rebate.fragment";
import { RebateItemFragment } from "../fragments/rebateItem.fragment";

export const GET_REBATE = gql`
  query ($id: ID!, $after: ConnectionCursor) {
    rebate(id: $id) {
      ...Rebate
      rebateItems(
        paging: { first: 50, after: $after }
        sorting: [{ field: rebateAmount, direction: DESC }]
      ) {
        pageInfo {
          ...Page
        }
        edges {
          node {
            ...RebateItem
          }
        }
      }
    }
  }
  ${PageFragment}
  ${RebateFragment}
  ${RebateItemFragment}
`;
